import React from 'react';
import { CookiesProvider } from 'react-cookie';
import styled from 'styled-components';

import MainRouter from './MainRouter';
import { UserContextProvider } from '../contexts/UserContext';
import { ErrorContextProvider } from '../contexts/ErrorContext';
import { ModalContextProvider } from '../contexts/ModalContext';
import './App.css';

/* The App is responsible for defining the default layout. All pages / routes
   in the application will follow this template.
 */
const App = () => (
  <CookiesProvider>
    <ModalContextProvider>
      <ErrorContextProvider>
        <UserContextProvider>
          <AppContainer>
            <MainRouter/>
          </AppContainer>
        </UserContextProvider>
      </ErrorContextProvider>
    </ModalContextProvider>
  </CookiesProvider>
);

const AppContainer = styled.div`
  a {
    color: #000;
    cursor: pointer;
    text-decoration: none;

    &:hover, &.active {
      text-decoration: none;
      color: #009bdf;
    }
  }
`;

export default App;
